import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as optics from '../assets/customerOptics'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    customerOptics: optics.customerSettings,
    trackandtracedata: {
      LoadDate: {},
      DeliveryDate: {},
      DeliveryAddress: {}
    },
    ttlinkquerydata: {},
    ttresponsewatcher: false,
    ttlinkoptics: {
      spedLogo: 'https://vu-elog-optics.s3.eu-central-1.amazonaws.com/images/logos/HeaderBdk.png',
      spedImage: 'https://vu-elog-optics.s3.eu-central-1.amazonaws.com/images/backgrounds/BgBDKbunt.jpg',
      mainColor: '#2196f3',
      mainConstrastColor: '#ffffff',
      highlightColor: '#ff9800',
      highlightContrastColor: '#424242'
    }
  },
  mutations: {
    setTrackAndTraceData (state, payload) {
      state.trackandtracedata = payload
      state.trackandtracedata.referencequerynr = state.ttlinkquerydata.refAuftNr
    },
    setOrderData (state, payload) {
      state.ttlinkquerydata = payload
    },
    setResponseWatcher (state, payload) {
      state.ttresponsewatcher = payload
    },
    setCustomerStyle (state, payload) {
      if (payload in optics.customerSettings) { state.ttlinkoptics = state.customerOptics[payload] }
    }
  },
  actions: {
    async getTrackAndTraceData ({ commit }) {
      try {
        let starttime = new Date().getTime()
        let response = await axios.post(process.env.VUE_APP_REST_TT,
          this.state.ttlinkquerydata/*,
          {
            headers: { //Needs Keycloak
              Authorization: 'Bearer ' + this.state.dashboardjwttokens.accessToken // mind the space between 'Bearer ' and token!!
            }
          } */
        )
        // console.log(response)
        let endtime = new Date().getTime()
        if (response.data.statusCode === 200) {
          commit('setTrackAndTraceData', JSON.parse(response.data.body))
          commit('setResponseWatcher', false)
          Vue.prototype.$gtag.time({
            'name': 'successful Call',
            'value': (endtime - starttime),
            'event_category': 'API Call'
          })
        } else {
          commit('setResponseWatcher', true)
          Vue.prototype.$gtag.time({
            'name': 'unsuccessful Call',
            'value': (endtime - starttime),
            'event_category': 'API Call'
          })
          Vue.prototype.$gtag.event('unsuccessful Call', {
            'event_category': 'API Call',
            'event_label': 'response statuscode',
            'value': response.data.statusCode
          })
        }
      } catch (error) {
        console.log('could not retrieve auftrags data')
      }
    }
  },
  modules: {
  }
})
